export default "__VITE_ASSET__gAFjM0zo__"